import React, { Component } from 'react';
import { Card, CardHeader, CardBody, CardText } from 'reactstrap';
import ReactGA from 'react-ga';

export class AboutUs extends Component {
    componentDidMount() {
        ReactGA.set({ page: 'AboutUs' });
        ReactGA.pageview('/aboutus');
    }

    render() {
        const publicUrl = process.env.PUBLIC_URL;

        return (
            <div className="container pt-4 text-justify">

            <Card>
                <CardHeader><h4 className="text-center">About Kevin Mackin</h4></CardHeader>
                <CardBody>
                    <CardText tag="div">

                        <p><strong>Kevin Mackin</strong> has
                            earned a strong reputation on the island over the last several years for
                            providing honest and dutiful service for all our customers, both buyers and
                            sellers. We have established a long roster of satisfied clientele who value the
                            diligence and integrity we maintain. Promotion of properties, attracting
                            qualified buyers, and serving our customers is what drives us every day, seven
                            days a week.
                        </p>
                        <img alt="Palm Island Specialist" src={`${publicUrl}/images/gopher.png`} className="img-fluid float-left pr-3" />
                        <p>We have been so fortunate to live and work exclusively on the island the past
                            several years and are currently in the process of building our permanent
                            residence here in paradise. The relationships with all the people we’ve met and
                            done business with here on the island is of utmost importance. It is so
                            gratifying to see happy new owners enjoying their new
                            island lifestyle as well as it is to see former owners
                            profiting from their wise purchase and proceed to make new decisions for their
                            future
                        </p>
                        <p>We have learned through experience how great a vacation at one of our
                            island rental homes can be from those who have come to <strong>
                            Colony Don Pedro</strong> or the <strong>Palm
                            Island</strong> area in the past. Our focus is continuing to bring
                            that experience to new and old customers as well as making this a destination
                            that many will never want to leave, and to assist those who choose not to. A
                            beach front home in such a wonderful
                            coastal habitat is hard to find. Just off the island, we have spent just as
                            much time at Boca Grande, in the
                            town of Englewood, Gasparilla, and Charlotte County
                            Florida to know how much of a treasure the island is to the
                            locals as well.
                        </p>
                        <p>
                            To live and work in exquisite surroundings with such wonderful friends and
                            neighbors is a blessing we shall never take for granted.
                        </p>

                        <div className="text-center">
                            <img alt="Palm Island Specialist" src={`${publicUrl}/images/manatee.png`} className="img-fluid" />
                        </div>
                    </CardText>
                </CardBody>
                </Card>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AboutUs.jsx